module.exports = __webpack_public_path__ + "static/hair_brooch-1907faf3814bc8c074fb253dceedd3c3.jpg";